import { useState } from "react";
import PatientInfo1 from "./PatientInfo1";
import FoamCarving from "./FoamCarving";
import Submit from "../pages/submit/Submit";
import MuiStepper from "../components/stepper/MuiSteper";
import TfMeasurement from "../pages/patientMeasurement/TfMeasurement";
import ClinicInfo from "./ClinicInfo";
import PatientInfo2 from "./PatientInfo2";
import PatientReview from "./PatientReview";
import apiClient from "../common/apiClient";
import AccountNumberPage from "./AccountNumberPage";

const TfCheckSocket = () => {
  const [activeInnerStep, setActiveInnerStep] = useState(0);
  const [activeOuterStep, setActiveOuterStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [showSubmit, setShowSubmit] = useState(true);
  const [cart, setCart] = useState(Array(0));
  const [tempCart, setTempCart] = useState(Array(0));
  const [init, setInit] = useState(true);
  const [openClear,setOpenClear] = useState(false);
  const [showClear,setShowClear]= useState(true);
  const [tfMeasurementInnerStepsPM, setTFMeasurementInnerStepsPM] = useState([]);
  const [tfMeasurementInnerStepsPI, setTFMeasurementInnerStepsPI] = useState([]);

  const formTypeId = 4;
  const patientMeasurementStepId = 2;

  const loadCart = () => {
    setTempCart([]);

    apiClient.get("cart/" + formTypeId
    ).then(response => {
      setCart(response.data);
    }).catch(error =>{
      console.log(error)
    });
  }

  const joinedCart = () => {
    let uniqueMainCart = cart.filter(c => !tempCart.some(t => t.sourceId?.toLowerCase() === c.sourceId?.toLowerCase() || t.name === c.name));

    return uniqueMainCart.concat(tempCart);
  }


  const handleNext = () => {
    getFormSteps();
    loadCart();
    if (activeOuterStep === formData?.length - 1) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep + 1);
      setActiveInnerStep(0);
    }
  };

  const handleBack = () => {
    loadCart();
    if (activeOuterStep === 0) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep - 1);
    }
  };

  const handleClearBack = () => {
    loadCart();
    setActiveOuterStep(0);
    setActiveInnerStep(0);    
  };

  const handleClickOpen = (name) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShowSubmit(true);
  };

  const handleClickClearOpen = (name) =>{
    setOpenClear(true); 
  };

  const handleCloseClear = () => {
    setOpenClear(false);
    setShowClear(true);
  };

  const getFormSteps = (inactiveSteps = []) => {
    let formSteps = [];
    if (activeOuterStep === patientMeasurementStepId) {
      formSteps = [
        { id: 1, name: "Shape Creation", isActive: true },
        { id: 2, name: "Brim", isActive: true },
        { id: 4, name: "Modifications", isActive: true },
        { id: 5, name: "Angles", isActive: true },
        { id: 6, name: "Measurement Notes", isActive: true },
      ];
    } else {
      formSteps = [
        { id: 1, name: "Foam Carving", isActive: true },
        { id: 2, name: "Socket Material", isActive: true },
        { id: 3, name: "Suspension", isActive: true },
        { id: 4, name: "Mounting Plate", isActive: true },
        { id: 5, name: "Insert Material", isActive: true },
        { id: 6, name: "Earliest Ship Date", isActive: true },
        { id: 7, name: "Notes", isActive: true },
      ];
    }
    
    const activeFormSteps = formSteps.filter(fs => {
      if (!inactiveSteps.includes(fs.id)) {
        return fs;
      }
    })

    if (activeOuterStep === patientMeasurementStepId) {
      setTFMeasurementInnerStepsPM(activeFormSteps);
    } else {
      setTFMeasurementInnerStepsPI(activeFormSteps);
    }
  }

  const setActiveInnerStepById = (id) => {
    const formSteps = (activeOuterStep === patientMeasurementStepId) ? tfMeasurementInnerStepsPM : tfMeasurementInnerStepsPI;
    const innerStepIndex = formSteps.indexOf(formSteps.find(i => i.id === id));
    setActiveInnerStep(innerStepIndex);
  }

  const formData = [
    {
      id: 1,
      name: "Patient Information",
      innerSteps: [
        { id: 1, name: "Patient Info", isActive: true },
        { id: 2, name: "Amputation Level", isActive: true },
        { id: 3, name: "Amputation Side", isActive: true },
        { id: 4, name: "K Level", isActive: true },
      ],
      formContent: (
        <PatientInfo1
          disableBackButton={localStorage.getItem("internalAccount") === null}
          setActiveInnerStep={setActiveInnerStep}
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
          handleClearBack = {handleClearBack}   
        />
      ),
    },

    {
      id: 2,
      name: "Socket Design Specifications",
      innerSteps: tfMeasurementInnerStepsPM,
      formContent: (
        <TfMeasurement
          setActiveInnerStep={setActiveInnerStepById}
          handleNext={handleNext}
          formTypeId={formTypeId}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
          handleClearBack = {handleClearBack}
          getFormSteps = {getFormSteps}          
        />
      ),
    },

    {
      id: 3,
      name: "Product Information",
      innerSteps: tfMeasurementInnerStepsPI,
      formContent: (
        <FoamCarving
          setActiveInnerStep={setActiveInnerStepById}
          handleNext={handleNext}
          formTypeId={formTypeId}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
          handleClearBack = {handleClearBack} 
          getFormSteps = {getFormSteps}          
        />
      ),
    },

    {
      id: 6,
      name: "Customer information",
      innerSteps: [],
      formContent: (
        <ClinicInfo
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
          handleClearBack = {handleClearBack}
        />
      ),
    },

    {
      id: 7,
      name: "Shipping Information",
      innerSteps: [],
      formContent: (
        <PatientInfo2
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
          handleClearBack = {handleClearBack}
        />
      ),
    },

    {
      id: 8,
      name: "Order Review",
      innerSteps: [],
      formContent: (
        <PatientReview
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          formName="TF Check Socket"
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
          handleClearBack = {handleClearBack}   
        />
      ),
    },

    {
      id: 9,
      name: "Submit",
      innerSteps: [],
      formContent: <Submit />,
    },
  ];

  if(localStorage.getItem("internalAccount")) {
    formData.unshift({
      id: 0,
      name:"Account Number",
      formContent: (
        <AccountNumberPage 
          setActiveInnerStep={setActiveInnerStep}
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          loadCart={loadCart}
          handleClearBack = {handleClearBack}
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
        />
      )
    })
  }

  const totalIds = formData.reduce((count) => {
    return count + 1;
  }, 0);

  if(init) {
    loadCart();
    setInit(false);
  }

  return (
    <div>
      <MuiStepper
        data={formData}
        innerStep={activeInnerStep}
        setInnerStep={setActiveInnerStep}
        setActiveOuterStep={setActiveOuterStep}
        activeOuterStep={activeOuterStep}
        formName="TF Check Socket "
        totalSteps={totalIds}
        cart={joinedCart()}
      />
    </div>
  );
};

export default TfCheckSocket;